import { Component, componentMixin } from '@resn/gozer-core/component';
import ThreeObjectMixin from '@resn/gozer-core-mixins/three-object';
import FeatureSceneMixin from 'component/sections/xp1/feature-base/feature-scene-mixin';
import { LAYERS } from 'core/constants';
import getStore from 'core/store';
import { isMobile } from '@resn/gozer-env';
import * as THREE from 'three';

import BgArrows from './bg-arrows';
import SimpleQuad from 'component/gl/simple-quad';

const store = getStore();

@componentMixin(ThreeObjectMixin)
@componentMixin(FeatureSceneMixin)
class HomeHeroScene extends Component {
    options = {};

    props = {
        introPr: 0,
        introThickness: 0,
    };

    tweens = {
        introPr: 0,
        introThickness: 0,
    };

    async onSetup() {
        // await this.setupArrowTop();
        await this.setupBgArrows();

        if (isMobile) await this.setupMask();
    }

    async setupBgArrows() {
        this.bgArrows = await new BgArrows().setup({
            options: {
                addTo: this.object,
                appendTo: this.el,
                layer: LAYERS.BACKGROUND,
            },
            props: {
                active: () => this.props.active,
                pX: () => this.props.bounds.width * -0.32,
                pY: () => (store.state.mobile ? this.props.bounds.width * 0.65 : 0),
            },
        });
    }

    async setupMask() {
        this.simpleQuad = await new SimpleQuad().setup({
            options: {
                addTo: this.object,
                layer: LAYERS.BACKGROUND,
                shader: new THREE.ShaderMaterial({ colorWrite: false }),
            },
            props: {
                s: () => [this.props.bounds.width, this.props.bounds.height * 0.6, 1],
                pY: (props) => props.s[1] * -0.3,
                pZ: 0.2,
            },
        });
    }

    onActive() {
        // const { mobile, route } = store.state;
        // const elDur = mobile ? 2 : 4;
        // if (route.first) {
        //     gsap.to(this.tweens, {
        //         introPr: 1,
        //         duration: elDur,
        //         ease: 'expo.out',
        //         onUpdate: () => {
        //             this.props.introPr = this.tweens.introPr;
        //         },
        //     });
        //     gsap.to(this.tweens, {
        //         introThickness: 1,
        //         duration: elDur,
        //         ease: 'power2.out',
        //         onUpdate: () => {
        //             this.props.introThickness = this.tweens.introThickness;
        //         },
        //     });
        //     this.bgArrows.props.active = true;
        // } else {
        //     this.props.introPr = this.tweens.introPr = 1;
        //     this.props.introThickness = this.tweens.introThickness = 1;
        // }
    }

    update() {
        this.bgArrows.update();
    }

    onDestroy() {
        // gsap.killTweensOf(this.tweens);
    }
}

export default HomeHeroScene;
